import axios from '@/api/axios';
import { defineStore } from 'pinia';

export default defineStore('chat', {
	state: () => ({
		messages: [] as any[],
		loading: false,
	}),
	actions: {
		// fetch messages for conversation (paginated)
		// returns axios response so components may access pagination meta
		async fetchMessages(
			uuid: string,
			opts: { per_page?: number } = { per_page: 30 }
		) {
			// this.loading = true;
			try {
				const res = await axios.get(`/chat/conversations/${uuid}/messages`, {
					params: { per_page: opts.per_page },
				});
				// backend returns paginated data in data.data - keep it flexible
				// ensure messages are normalized descending by created_at
				const payload = res.data;
				// if backend returns pagination object
				if (payload && payload.data) {
					this.messages = payload.data;
				} else if (Array.isArray(payload)) {
					this.messages = payload;
				} else {
					this.messages = [];
				}
				return res;
			} catch (e) {
				console.error(e);
				throw e;
			} finally {
				this.loading = false;
			}
		},

		// send message is handled directly by composer but we keep a helper
		async sendMessage(conversationUuid: string, formData: FormData) {
			try {
				const res = await axios.post(
					`/chat/conversations/${conversationUuid}/messages`,
					formData,
					{
						headers: { 'Content-Type': 'multipart/form-data' },
					}
				);
				// prepend to messages (backend returns created message)
				this.messages.unshift(res.data);
				return res.data;
			} catch (e) {
				console.error(e);
				throw e;
			}
		},

		async markMessageRead(messageUuid: string) {
			try {
				const res = await axios.put(`/chat/messages/${messageUuid}/mark-read`);
				return res.data;
			} catch (e) {
				console.error(e);
				throw e;
			}
		},

		async markMessageUnread(messageUuid: string) {
			try {
				const res = await axios.put(
					`/chat/messages/${messageUuid}/mark-unread`
				);
				return res.data;
			} catch (e) {
				console.error(e);
				throw e;
			}
		},
	},
});
